import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { threads } from '@/mocks/home';

const STATUS_STYLE: Record<string, string> = {
  持续更新: 'bg-primary-100 text-primary-700',
  新线索: 'bg-accent-100 text-accent-900',
  已回应: 'bg-secondary-100 text-secondary-800',
};

export default function ThreadSection() {
  const [active, setActive] = useState(0);
  const current = threads[active];

  return (
    <section id="thread" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <SectionHeading
          no="02"
          title="线索追踪"
          en="Story Threads"
          desc="把同一条线索按时间串起来，旧料新料一条不落，想看后续变化就盯这里。"
        />

        <div className="grid gap-6 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex flex-col gap-3">
              {threads.map((thread, index) => {
                const isActive = index === active;
                return (
                  <button
                    key={thread.id}
                    type="button"
                    onClick={() => setActive(index)}
                    className={`flex w-full items-center gap-4 rounded-lg border p-3 text-left transition-colors ${
                      isActive
                        ? 'border-primary-300 bg-background-50'
                        : 'border-background-200 bg-background-50/60 hover:bg-background-50'
                    }`}
                  >
                    <span className="h-14 w-14 flex-none overflow-hidden rounded-md">
                      <img
                        src={thread.cover}
                        alt={`${thread.title} - 黑料51黑料线索追踪`}
                        title={`${thread.title} 黑料51黑料动态`}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2">
                        <span className="truncate font-heading text-base font-bold text-foreground-950">
                          {thread.title}
                        </span>
                        <span
                          className={`flex-none rounded px-1.5 py-0.5 text-[11px] font-medium ${
                            STATUS_STYLE[thread.status] ?? 'bg-background-200 text-foreground-700'
                          }`}
                        >
                          {thread.status}
                        </span>
                      </span>
                      <span className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-node-tree text-sm" />
                          {thread.updates.length} 次更新
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-fire-line text-sm text-primary-500" />
                          {thread.heat}
                        </span>
                      </span>
                    </span>
                    <i
                      className={`flex-none text-lg ${
                        isActive ? 'ri-arrow-right-line text-primary-500' : 'ri-arrow-right-s-line text-foreground-300'
                      }`}
                    />
                  </button>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
              <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200 pb-4">
                <div>
                  <p className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-400">
                    Thread Timeline
                  </p>
                  <h3 className="mt-1 font-heading text-lg font-black text-foreground-950 md:text-xl">
                    {current.title}
                  </h3>
                </div>
                <span className="flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-500 hl-pulse" />
                  正在跟进
                </span>
              </div>

              <div className="mt-6">
                {current.updates.map((update, index) => (
                  <div key={`${current.id}-${index}`} className="relative pl-8 pb-6 last:pb-0">
                    {index < current.updates.length - 1 && (
                      <span className="absolute left-[7px] top-4 h-full w-px bg-background-300" />
                    )}
                    <span className="absolute left-0 top-0.5 h-4 w-4 rounded-full border-2 border-background-50 bg-accent-500" />
                    <p className="font-label text-xs tracking-wide text-foreground-500">
                      {update.time}
                    </p>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-800">
                      {update.text}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-2 flex flex-wrap items-center gap-3 border-t border-background-200 pt-5">
                <a
                  href="#submit"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  补充这条线索
                </a>
                <a
                  href="#rank"
                  className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
                >
                  看它排第几
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}